import axios from 'axios';
import apiEndpoints from './endpoint';
import { getIdpType, getJWToken } from '../utils/windowUtils';

const setupApi = async ({ jwt, origin, idpType }) => {
  const idpTypeModel = idpType || getIdpType();
  const jwToken = jwt || getJWToken();

  axios.defaults.baseURL = origin;

  switch (idpTypeModel) {
    case 'auth0':
      try {
        const response = await axios.get(apiEndpoints.idpEndpoint);
        if (response && response.data) {
          const authToken = response.data[0].access_token;
          axios.defaults.headers.common.Authorization = `Bearer ${authToken}`;
        }
      } catch (error) {
        axios.defaults.headers = {
          ...axios.defaults.headers,
          Authorization: `Bearer ${jwToken}`
        };
      }
      axios.interceptors.response.use(
        (response) => response,
        async (error) => {
          const { config } = error;
          const status = error.response ? error.response.status : null;
          if (status === 401) {
            if (config.retry) {
              config.retry += 1;
            } else {
              config.retry = 1;
            }
            try {
              const response = await axios.get(apiEndpoints.idpEndpoint);
              if (response && response.data && config.retry < 3) {
                const accessToken = response.data[0].access_token;
                axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
                config.headers.Authorization = `Bearer ${accessToken}`;
                const res = axios.request(config);
                return res;
              }
            } catch (err) {
              return err;
            }
          }
          return error;
        }
      );
      break;
    case 'fuse':
    default:
      axios.defaults.headers = {
        ...axios.defaults.headers,
        Authorization: `Bearer ${jwToken}`
      };
      break;
  }
};

const get = async (url, config) => {
  try {
    const res = await axios.get(url, config);
    return res.data;
  } catch (err) {
    throw err;
  }
};

const post = async (url, data, config) => {
  try {
    const res = await axios.post(url, data, config);
    return res.data;
  } catch (err) {
    throw err;
  }
};

const deleteReq = async (url, data, config) => {
  try {
    const res = await axios.delete(url, data, config);
    return res.data;
  } catch (err) {
    throw err;
  }
};

const putReq = async (url, data, config) => {
  try {
    const res = await axios.put(url, data, config);
    return res.data;
  } catch (err) {
    throw err;
  }
};

export { setupApi, get, post, deleteReq, putReq };
